<div class="auth-container">
    <router-outlet></router-outlet>
</div>
